import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { Toast } from 'vant'
import { removeToken } from './auth'

function generateUUID() {
  return 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
// create an axios instance
// 创建一个axios实例
// console.log(process.env.VUE_APP_BASE_API, 'process.env.VUE_APP_BASE_API')
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 600 * 1000, // request timeout,
  headers: {
    ClientId: '01000000',
    ReqTime: Date.now().toString(),
    ReqId: generateUUID()
  }
})

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const token = store.state.user.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    if (response.data instanceof Blob) return response.data

    const { code, msg } = response.data
    if (code == 0) {
      return response.data
    } else {
      if(code == 10013) {
        removeToken()
        Toast.fail('token超时了')
        router.push('/login')
      }else {
       Toast.fail(msg)
       return Promise.reject(new Error(msg))
      }
      
    }
    // return response.data
  },
  (error) => {
    if (error.response.code == 10013) {
      Toast.fail('token超时了')
      // store.dispatch('user/logoutActions') // 退出登入
      removeToken()
      router.push('/login') // 跳转到登入页面
    }
    return Promise.reject(error)
  }
)

export default request
